/* Beautify-inspired product gallery navigation.
   - Desktop (thumbnail layout): arrows/dots activate media like a thumbnail click.
   - Mobile (scroll slider): arrows/dots smooth-scroll the slider; dots track swipes.
   Works with Dawn's media-gallery.js (setActiveMedia) and slider markup. */
(function () {
  if (window.ckGalleryLoaded) return;
  window.ckGalleryLoaded = true;

  function initGallery(gallery) {
    if (gallery.dataset.ckGalleryInit === 'true') return;
    gallery.dataset.ckGalleryInit = 'true';

    var list = gallery.querySelector('.product__media-list');
    if (!list) return;

    var dotsWrap = gallery.querySelector('[data-ck-gallery-dots]');
    var prevBtn = gallery.querySelector('[data-ck-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-ck-gallery-next]');

    function slides() {
      return Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    }

    function isMobileSlider() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function activeIndex() {
      var items = slides();
      if (!items.length) return 0;
      if (isMobileSlider()) {
        // Nearest slide center to the viewport's horizontal midpoint —
        // robust across the column-gap between slides.
        var first = items[0].offsetLeft;
        var mid = list.scrollLeft + list.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < items.length; i++) {
          var center = items[i].offsetLeft - first + items[i].offsetWidth / 2;
          var dist = Math.abs(mid - center);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        }
        return best;
      }
      for (var j = 0; j < items.length; j++) {
        if (items[j].classList.contains('is-active')) return j;
      }
      return 0;
    }

    function goTo(index) {
      var items = slides();
      if (!items.length) return;
      var i = ((index % items.length) + items.length) % items.length;
      if (isMobileSlider()) {
        var first = items[0].offsetLeft;
        list.scrollTo({ left: items[i].offsetLeft - first, behavior: 'smooth' });
      } else {
        var id = items[i].getAttribute('data-media-id');
        var thumb = gallery.querySelector('[data-target="' + id + '"] button');
        if (thumb) {
          thumb.click();
        } else if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(id, false);
        }
      }
      update();
    }

    function update() {
      if (!dotsWrap) return;
      var i = activeIndex();
      Array.prototype.forEach.call(dotsWrap.children, function (dot, j) {
        dot.classList.toggle('is-active', j === i);
        dot.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    // Build one dot per rendered slide (always in sync with the actual gallery).
    // Labels come from Liquid-translated data attributes for localization.
    var labelTemplate = dotsWrap ? dotsWrap.getAttribute('data-label') || 'Slide' : 'Slide';
    var labelOf = dotsWrap ? dotsWrap.getAttribute('data-label-of') || 'of' : 'of';
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var items = slides();
      items.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ck-gallery__dot';
        dot.setAttribute('aria-label', labelTemplate + ' ' + (i + 1) + ' ' + labelOf + ' ' + items.length);
        dot.addEventListener('click', function () {
          goTo(i);
        });
        dotsWrap.appendChild(dot);
      });
    }
    buildDots();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex() + 1);
      });
    }

    // Mobile: keep dots synced while swiping (rAF-throttled).
    var raf = null;
    list.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        update();
      });
    });

    // Keep dots synced with the gallery:
    // - class changes on slides (thumbnail clicks, variant switches) → update
    // - slides added/removed/reordered (Dawn's updateMedia on variant change) → rebuild
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        // Rebuild only when slides themselves change (li added/removed on the
        // ul) — not when content inside a slide loads (e.g. deferred video).
        if (mutations[m].type === 'childList' && mutations[m].target === list) {
          buildDots();
          break;
        }
      }
      update();
    });
    observer.observe(list, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    window.addEventListener('resize', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        update();
      });
    });

    update();
  }

  function initAll(scope) {
    var galleries = (scope || document).querySelectorAll('media-gallery[data-ck-gallery]');
    Array.prototype.forEach.call(galleries, initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
